import { Component, DestroyRef, inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { Selectable } from '../../models/types/selectable.type';
import { FormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatButtonModule } from '@angular/material/button';
import { MatInputModule } from '@angular/material/input';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { MatChipsModule } from '@angular/material/chips';
import { CommonModule } from '@angular/common';
import { FilterDialogData } from '../../models/types/filter-dialog-data.type';
import { SharedModule } from '../../shared.module';
import { OrderStatus } from 'src/app/models/common/order-status.models';
import { OrderStatusFilterService } from '../../services/filters/order-status-filter.service';
import { GraphQLService } from 'src/app/services/graph-ql.service';
import { OrderQueries } from 'src/app/models/shared/enums/get-query';
import { WrapperResultGraphQL } from 'src/app/models/shared/types/wrapper-result-graphql.type';
import { map } from 'rxjs';
import { MatSelectModule } from '@angular/material/select';

@Component({
	selector: 'bt-change-order-status',
	standalone: true,
	imports: [MatDialogModule, MatIconModule, FormsModule, MatFormFieldModule, MatButtonModule, MatInputModule, MatSelectModule, CommonModule, SharedModule],
	templateUrl: './change-order-status.component.html',
	styleUrl: './change-order-status.component.scss'
})
export class ChangeOrderStatusComponent {
	readonly #destroyRef = inject(DestroyRef);
	readonly #dialogRef = inject(MatDialogRef<ChangeOrderStatusComponent>);
	readonly #graphQlService = inject(GraphQLService);
	readonly data = inject(MAT_DIALOG_DATA);

	datasource: Array<{ id: number, name: string }> = [];
	selectedStatus: number;
	onClose(): void {
		this.#dialogRef.close();
	}

	ngOnInit(): void {
		this.#graphQlService.getData(OrderQueries.GET_ORDER_STATUSES_NO_IDS, { first: 50 })
		.pipe(
			takeUntilDestroyed(this.#destroyRef),
			map(res => res['data']['orderStatuses'])
		)
		.subscribe({
			next: (res) => {
				this.datasource = res.nodes;
			}
		});
	}

}
